import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { ROUTE_CHECKOUT, ROUTE_THANK_YOU } from "../constants";
import { useAppSelector } from "../redux/store/store";

const BranchBannerController = () => {
  const location = useLocation();
  const showCart = useAppSelector((state) => state.cart.showCart);
  const retryTimeoutRef = useRef(null);
  const retryCountRef = useRef(0);

  const applyBannerStyles = (shouldHideBanner) => {
    const body = document.body;
    const iframe = document.getElementById("branch-banner-iframe");

    if (!iframe) {
      return false; // Banner not found
    }

    if (shouldHideBanner) {
      body.style.transition = "margin-top 0.375s ease";
      
      iframe.style.transition = "opacity 0.375s ease, transform 0.375s ease";
      iframe.style.opacity = "0";
      iframe.style.transform = "translateY(-100%)";

      // Hide after animation completes
      setTimeout(() => {
        iframe.style.display = "none";
      }, 375);

      body.style.marginTop = "0px";
      body.classList.remove("branch-banner-is-active");
    } else {
      body.style.transition = "margin-top 0.375s ease";
      
      iframe.style.display = "block";
      iframe.style.transition = "opacity 0.375s ease, transform 0.375s ease";
      body.style.marginTop = "76px";
      body.classList.add("branch-banner-is-active");
      
      setTimeout(() => {
        iframe.style.opacity = "1";
        iframe.style.transform = "translateY(0)";
      }, 10);
    }

    return true; // Banner found and styles applied
  };

  useEffect(() => {
    // Clear any existing retry timeout
    if (retryTimeoutRef.current) {
      clearTimeout(retryTimeoutRef.current);
      retryTimeoutRef.current = null;
    }

    // Reset retry count on location/cart change
    retryCountRef.current = 0;

    const pagesWithoutBanner = [ROUTE_CHECKOUT, ROUTE_THANK_YOU];

    const isRestrictedPage = pagesWithoutBanner.some(
      (path) => location.pathname === path
    );

    const shouldHideBanner = showCart || isRestrictedPage;

    const tryApplyStyles = () => {
      const success = applyBannerStyles(shouldHideBanner);

      if (!success && retryCountRef.current < 3) {
        // Banner not found, retry after a delay
        retryCountRef.current += 1;
        const delay = retryCountRef.current * 1000; // 1s, 2s, 3s

        retryTimeoutRef.current = setTimeout(() => {
          tryApplyStyles();
        }, delay);
      }
    };

    // Initial attempt
    tryApplyStyles();

    // Cleanup on unmount
    return () => {
      if (retryTimeoutRef.current) {
        clearTimeout(retryTimeoutRef.current);
      }
    };
  }, [location.pathname, showCart]);

  return null;
};

export default BranchBannerController;